<template>
  <v-fade-transition>
    <v-layout align-senter justify-center transition="scale-transition">
      <v-flex xs12 py-2>
        <v-card v-if="firstName" origin="center center">
          <v-layout layout row wrap justify-center align-start>
            <v-flex xs3>
              <v-img :src="img" aspect-ratio="1"
                     class="img-transition elevation-2" :alt="'Profile picture from '+ firstName + ' ' + lastName"></v-img>
              <div v-if="categories">
                <v-chip v-for="(cat,key) in categories" :key="key"
                        v-if="cat.length >1"
                        label
                        outline
                        :color="colorCat(cat)">{{cat}}
                </v-chip>
              </div>
            </v-flex>
            <v-flex xs9>
              <v-card-title>
                <v-layout wrap>
                  <v-flex xs12>
                    <h1>{{firstName}} {{lastName}}</h1>
                  </v-flex>
                  <v-flex xs12 v-if="infoText">
                    <div v-html="infoText"></div>
                  </v-flex>
                  <v-flex xs12 mt-1 v-if="connectedPeople">
                    <span class="body-2"> {{connectedPeopleHeadline}}:</span>
                    <span v-for="(person, key, index) in connectedPeople" :key="key">
                        {{
                           person.firstName + ' ' + person.lastName}}{{
                           Object.keys(connectedPeople).length > index+1 ? ', ' : ''
                        }}
                      </span>
                  </v-flex>
                  <v-flex xs12 mt-1 v-if="email || phone">
                    <v-flex class="subheading xs12 mt-3"> Kontakt: </v-flex>
                    <v-flex xs12 v-if="phone"><span class="body-2">☎ Phone: </span> {{phone}}</v-flex>
                    <v-flex xs12 v-if="email"><span class="body-2">📧 E-Mail:</span> {{email}}</v-flex>
                  </v-flex>
                </v-layout>
              </v-card-title>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-layout row wrap>
                <v-flex>
                  <slot name="container"></slot>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-fade-transition>
</template>

<script>
  import AthleteTrophyTable from "../athlete/trophy/TrophyTable";

  export default {
    name: "ChosenPerson",
    components: {AthleteTrophyTable},
    props: {
      firstName: {
        type: String,
        required: true
      },
      lastName: {
        type: String,
        required: true
      },
      phone: {
        type: String,
        required: false
      },
      email: {
        type: String,
        required: false
      },
      img: {
        type: String,
        required: true
      },
      infoText: {
        type: String,
        required: false
      },
      categories: {
        type: Array,
        required: false
      },
      connectedPeople: {
        type: Array | Object,
        required: false
      },
      connectedPeopleHeadline: {
        type: Array | Object,
        required: false
      },
    },
    data() {
      return {
        catColorObj: {
          'Meisterklasse': 'amber',
          Junioren: 'orange',
          Jugend: 'deep-purple',
          'Nachwuchs A': 'orange',
          'Nachwuchs B': 'orange',
          'Nachwuchs': 'light-blue darken-2',
          'Neulinge': 'green',
          'Anfänger': 'purple accent-3',
          'Sternschnuppen': 'pink accent-1',
          'Erwachsene': 'red darken-2'
        },
      }
    },
    methods: {
      colorCat(cat) {
        return this.catColorObj[cat] ? this.catColorObj[cat] : 'black'
      },
    },
  }
</script>

